import { axios, Response } from '../index'

const deletePublication = (postId: number): Response<void> => {
  return axios.delete(`/v1/posts/${postId}`)
}

export default deletePublication
